module.exports = __webpack_public_path__ + "972c3d1e893a7230952de12a84491702.pdf";